import { LoadingSpinner } from '@/components/common/loading-spinner';
import { useAuth } from '@/utils/auth-utils';
import { Navigate, Outlet } from 'react-router-dom';
import ROUTES from './path';
import { ROLE } from '@/constants';
import { consoleError } from '@/utils/common-utils';

export const CreatorRoute = () => {
  const { user, loading, idTokenResult } = useAuth();
  if (loading) return <LoadingSpinner />;

  if (user) {
    if (idTokenResult?.claims?.role === ROLE.creator) {
      return <Outlet />;
    } else {
      consoleError('failed to authenticate the user', idTokenResult);
      return <Navigate to="*" replace />;
    }
  } else {
    return <Navigate to={ROUTES.login} replace />;
  }
};

export const CommonRoute = () => {
  const { user, loading } = useAuth();
  if (loading) return <LoadingSpinner />;
  return user ? <Outlet /> : <Navigate to={ROUTES.login} />;
};
